
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2074.781-1761.67h11.553a2.818 2.818 0 001.572-.322 1.092 1.092 0 00.449-.947 3.894 3.894 0 00-.542-1.88 6.611 6.611 0 00-1.562-1.841 8.275 8.275 0 00-2.456-1.4 9.172 9.172 0 00-3.232-.537 9.213 9.213 0 00-3.237.537 8.194 8.194 0 00-2.456 1.4 6.644 6.644 0 00-1.554 1.841 3.894 3.894 0 00-.542 1.88 1.092 1.092 0 00.449.947 2.794 2.794 0 001.558.322zm5.791-8.574a3.343 3.343 0 001.844-.542 4.02 4.02 0 001.357-1.47 4.247 4.247 0 00.513-2.09 4.032 4.032 0 00-.513-2.026 3.954 3.954 0 00-1.357-1.43 3.472 3.472 0 00-3.687 0 4 4 0 00-1.868 3.476 4.24 4.24 0 00.508 2.07 3.981 3.981 0 001.353 1.47 3.359 3.359 0 001.85.542z"}})])])
          )
        }
      }
    